module.exports = __webpack_public_path__ + "media/assets_v3/images/user-panel/confirm-account-e2d0f2afdd0480f6d37198a0a6dece75.jpeg";